import { CHANGE_CLIENT, CHANGE_TOKEN_STATE, GENERAL_USER_REDUCER, RESET_USER_DATA, } from "../user/types";
import { async_func_data, handleResponse } from "../Utils/helperfunctions";
import { ERROR_OCCURED, FORBIDDEN, SUCCESS_CODE, } from "./../../constants/return_code_constants";
import { sendAlert } from "./../global/actions";
import { currentClientSelector, isAdvisorSelector } from "./selectors";
const getCookie = (name) => {
    const doc = typeof globalThis !== 'undefined' ? globalThis.document : null;
    if (!doc)
        return null;
    const value = `; ${doc.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const lastPart = parts.pop();
        if (lastPart)
            return lastPart.split(';').shift() || null;
    }
    return null;
};
export const getUser = () => async (dispatch, getState) => {
    // If token is missing in state but present in cookie, sync it to state
    const currentToken = getState().userReducer.token;
    const cookieToken = getCookie('jwt_token');
    if (!currentToken && cookieToken) {
        dispatch(changeTokenState(cookieToken));
    }
    const { responseData, errorCode } = await async_func_data("user/getuser", null, [getState, dispatch], "get");
    handleResponse(errorCode, dispatch, generalUserAction({ userData: responseData }));
    return responseData;
};
export const does_user_exist = (email) => async (dispatch, getState) => {
    const { responseData } = await async_func_data("user/getUserType", { email: email.trim() }, [getState, dispatch], "get", false);
    return responseData.types.length;
};
export const login_user = (email, password, type) => async (dispatch, getState) => {
    const { responseData: resData } = await async_func_data("user/getUserType", { email: email.trim() }, [getState, dispatch], "get", false);
    // If user doesnt exist with the email handle that case
    // The intial response returens empty array if email doesnt exsist
    if (resData.types.length) {
        if (type && !resData.types.includes(type)) {
            dispatch(sendAlert({ title: "Error", textContent: "Login failed." }));
            return ERROR_OCCURED;
        }
        const params = {
            email: email.trim(),
            password,
            userType: type ? type : resData.types[0],
        };
        if (getState().userReducer.viaEmail) {
            params.viaEmail = true;
            params.userAdvisorId = getState().userReducer.userAdvisorId;
        }
        const { responseData, errorCode } = await async_func_data("user/signIn", params, [getState, dispatch], "post", false);
        const { token } = responseData;
        if (type === "admin") {
            if (errorCode === SUCCESS_CODE) {
                return token;
            }
            else {
                return null;
            }
        }
        return handleResponse(errorCode, dispatch, 
        // If admin dont save token
        generalUserAction({ token, viaEmail: null }));
    }
    else {
        dispatch(sendAlert({ title: "Error", textContent: "Login failed." }));
    }
    return ERROR_OCCURED;
};
export const google_login = (tokenId, platform) => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("user/google/oauth", {
        access_token: tokenId,
    }, [getState, dispatch], "post", false);
    const { token } = responseData;
    if (token) {
        return handleResponse(errorCode, dispatch, changeTokenState(token));
    }
    else {
        dispatch(sendAlert({
            title: "Error",
            textContent: "Could not connect with Google.",
        }));
    }
};
export const facebook_login = (tokenId, platform) => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("user/facebook/oauth", {
        access_token: tokenId,
        platform,
    }, [getState, dispatch], "post", false);
    const { token } = responseData;
    if (token) {
        return handleResponse(errorCode, dispatch, changeTokenState(token));
    }
    else {
        dispatch(sendAlert({
            title: "Error",
            textContent: "Could not connect with Facebook.",
        }));
    }
};
export const logout_user = () => async (dispatch) => {
    dispatch(changeTokenState(null));
    const doc = typeof globalThis !== 'undefined' ? globalThis.document : null;
    if (doc) {
        doc.cookie = "jwt_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
};
export const user_signup = (data, advisor = false, userAdvisorId, advisorAddress) => async (dispatch, getState) => {
    const _data = !advisor
        ? { ...data, userType: "primary" }
        : {
            ...data,
            viaEmail: true,
            userType: "advisor",
            userAdvisorId,
            advisorAddress,
        };
    const { errorCode } = await async_func_data("user/signUp", _data, [getState, dispatch], "post", false);
    if (errorCode === SUCCESS_CODE) {
        dispatch(generalUserAction({ register_success: true }));
    }
    else {
        dispatch(generalUserAction({ register_success: false }));
        if (errorCode === FORBIDDEN) {
            dispatch(sendAlert({
                title: "Error",
                textContent: "This Email is already registered.",
            }));
        }
        else {
            dispatch(sendAlert({ title: "Error", textContent: "Registration failed." }));
        }
    }
};
export const resendActivationEmail = (email) => async (dispatch, getState) => {
    const { errorCode } = await async_func_data("user/resendEmail", { email: email?.trim() }, [getState, dispatch], "post");
    if (errorCode === SUCCESS_CODE) {
        return handleResponse(errorCode, dispatch, null);
    }
};
// Get all user advisors
export const get_advisors = () => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("advisor/getAllAdvisor", null, [getState, dispatch], "get");
    const { data } = responseData;
    if (errorCode === SUCCESS_CODE) {
        dispatch(generalUserAction({ client: { advisors: data } }));
    }
};
export const add_advisor = (email) => async (dispatch, getState) => {
    const { errorCode } = await async_func_data("advisor/create", { email: email.trim() }, [getState, dispatch], "post");
    if (errorCode === SUCCESS_CODE) {
        dispatch(sendAlert({
            title: "Email sent to Advisor",
            textContent: "Once they activate, we will provide access to your Plootus account.",
        }));
    }
};
export const delete_advisor = (id) => async (dispatch, getState) => {
    const { errorCode } = await async_func_data("advisor/delete", { id }, [getState, dispatch], "delete");
    if (errorCode === SUCCESS_CODE) {
        dispatch(sendAlert({ title: "Success", textContent: "Advisor Removed" }));
    }
};
export const get_clients = () => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("advisor/getAllUser", null, [getState, dispatch], "get");
    const { data } = responseData;
    if (errorCode === SUCCESS_CODE) {
        dispatch(generalUserAction({
            advisor: {
                ...getState().userReducer.advisor,
                clients: data?.[0]?.primaryUsers || [],
            },
        })); // Have to change interface of Client according to backend data
    }
    return data?.[0]?.primaryUsers || [];
};
export const updateProfile = (data, shouldUpdateClient) => async (dispatch, getState) => {
    const isAdvisor = isAdvisorSelector(getState());
    const userId = isAdvisor ? currentClientSelector(getState())?.uuid : null;
    const { errorCode } = await async_func_data(isAdvisor && shouldUpdateClient
        ? `user/updateUser?userId=${userId}`
        : "user/updateUser", data, [getState, dispatch], "post");
    if (errorCode === SUCCESS_CODE) {
        // In future send floating alert that profile updated
    }
    else {
        dispatch(sendAlert({ title: "Error", textContent: "Profile Update failed." }));
    }
    return errorCode;
};
export const getAccounts = (userId) => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("account/getAllAccounts", { userId }, [getState, dispatch], "get");
    handleResponse(errorCode, dispatch, generalUserAction({ accounts: responseData }));
};
export const deleteAccount = (acc_id) => async (dispatch, getState) => {
    const { errorCode } = await async_func_data("account/deleteAccount", { acc_id }, [getState, dispatch], "delete");
    if (errorCode === SUCCESS_CODE) {
        dispatch(sendAlert({
            title: "Account Deleted",
            textContent: "Account deleted successfully",
        }));
        return SUCCESS_CODE;
    }
    else {
        dispatch(sendAlert({ title: "Error", textContent: "Deletion failed." }));
    }
};
export const forgotPassword = (email) => async (dispatch, getState) => {
    const { responseData: resData } = await async_func_data("user/getUserType", { email: email.trim() }, [getState, dispatch], "get", false);
    if (resData.types.length) {
        const { errorCode } = await async_func_data("user/forgotPasswordEmail", {
            email: email.trim(),
            userType: resData.types[0],
        }, [getState, dispatch], "get", false);
        return errorCode;
    }
    else {
        dispatch(sendAlert({ title: "Error", textContent: "Password Reset Failed." }));
        return ERROR_OCCURED;
    }
};
export const confirmPassword = (id, password, vt) => async (dispatch, getState) => {
    const { errorCode } = await async_func_data("user/forgotPasswordNew", { id, newPassword: password, vt }, [getState, dispatch], "post", false);
    return errorCode;
};
export const generalUserAction = (payload) => ({
    type: GENERAL_USER_REDUCER,
    payload,
});
export const changeTokenState = (token) => ({
    type: CHANGE_TOKEN_STATE,
    payload: {
        token,
    },
});
export const setChoosenClient = (index) => ({
    type: CHANGE_CLIENT,
    payload: index,
});
export const resetUser = () => ({
    type: RESET_USER_DATA,
});
